import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './app/store';
import { Provider } from 'react-redux';
import SuspenseContent from './containers/SuspenseContent';
import 'react-tooltip/dist/react-tooltip.css';
import { initializeSentry } from './utils/sentry';
import { setupSentryStoreSubscriber } from './utils/sentryStoreSubscriber';

// Initialize Sentry for error tracking
initializeSentry(store);

// Set up Redux store subscriber to update Sentry organization context
setupSentryStoreSubscriber(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<Suspense fallback={<SuspenseContent />}>
		<Provider store={store}>
			<App />
		</Provider>
	</Suspense>
);

// Register the unified service worker (PWA + Firebase messaging)
if ('serviceWorker' in navigator) {
	window.addEventListener('load', async () => {
		try {
			console.log('Registering unified service worker...');
			const registration = await navigator.serviceWorker.register(
				'/service-worker.js',
				{
					scope: '/',
				}
			);

			console.log(
				'Service worker registered successfully:',
				registration.scope
			);

			// Listen for service worker updates
			registration.addEventListener('updatefound', () => {
				console.log('Service worker update found');
				const newWorker = registration.installing;

				if (newWorker) {
					newWorker.addEventListener('statechange', () => {
						if (
							newWorker.state === 'installed' &&
							navigator.serviceWorker.controller
						) {
							console.log('New service worker installed and waiting');
							// Set a flag to indicate an update is available
							sessionStorage.setItem('sw-update-available', 'true');
						}
					});
				}
			});

			// Listen for controller changes
			navigator.serviceWorker.addEventListener('controllerchange', () => {
				console.log('Service worker controller changed');
				// Reload to ensure the new service worker takes control
				if (!sessionStorage.getItem('sw-reloading')) {
					sessionStorage.setItem('sw-reloading', 'true');
					window.location.reload();
				}
			});

			// Listen for messages from the service worker
			navigator.serviceWorker.addEventListener('message', (event) => {
				if (event.data.action === 'reloadPage') {
					console.log('Reloading page as requested by service worker');
					sessionStorage.removeItem('sw-reloading');
					window.location.reload();
				}
			});
		} catch (error) {
			console.error('Service worker registration failed:', error);
		}
	});
}
